<template>
  <div
    class="sub-scenario-cargo border-informacion-lf mt-4 p-2"
    v-if="sub_scenario.position_sub_scenario.length > 0"
  >
    <add-position
      v-for="(
        position_sub_scenario, index
      ) in sub_scenario.position_sub_scenario"
      :key="index"
      :index="index"
      :ref="'add-position' + index"
      :btnNuevo="false"
      :btnEditar="true"
      :position_id="position_sub_scenario.position.id"
      :puntos="parseFloat(position_sub_scenario.points)"
      :position_sub_scenario="position_sub_scenario"
      :sub_scenario="sub_scenario"
      :indexSubScenario="indexSubScenario"
      @eliminar="renderizar"
    ></add-position>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AddPosition from "./add-position.vue";
export default {
  name: "sub-scenario-cargo",
  components: { AddPosition },
  data() {
    return {};
  },
  props: ["sub_scenario", "indexSubScenario"],
  computed: {
    ...mapState("modScenarios", [
      "scenario",
      "scenarios",
      "scenarioselected",
      "loading",
      "loadingLineDeals",
      "error",
      "message",
      "history",
      "cargos",
      "loadingCargos",
    ]),
  },
  methods: {
    renderizar() {
      this.$forceUpdate();
    },
  },
};
</script>

<style>
/*.sub-scenario-cargo {
}*/
</style>